var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-content"},_vm._l((_vm.products),function(product,key){return _c('div',{key:key,staticClass:"item col-6"},[_c('product-block',{attrs:{"info":product,"gaEvent":_vm.gaEvent}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }